import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { jaJP } from '@material-ui/core/locale';

// Create a theme instance.
const theme = createMuiTheme(
  {
    palette: {
      primary: { main: '#f79502' },
      secondary: { main: '#564f4d' },
    },
  },
  jaJP
);

export default theme;
